@if (reportNames.length > 0) {
  <div class="report-toolbar-strip d-flex align-items-center flex-wrap gap-2 d-print-none mb-2">
    <ng-select
      class="report-select"
      [items]="reportNames"
      [(ngModel)]="selectedReportName"
      (change)="onReportChange()"
      placeholder="Please select..."
      i18n-placeholder
    ></ng-select>

    @if (viewer(); as activeViewer) {
      <div class="vr d-none d-md-block"></div>

      <!-- Paging and zoom only move through the document already loaded, so they are repeat-click
           buttons that answer every press. Email, Download, Print and Upload below start server
           work and stay guarded. -->
      <div class="d-flex align-items-center gap-1">
        <app-repeat-click-button
          buttonClass="btn btn-sm btn-outline-secondary border-0 px-2"
          [disabled]="activeViewer.page() <= 1"
          label="Previous page"
          i18n-label
          (clicked)="activeViewer.previousPage()"
        >
          <i class="fa fa-chevron-left"></i>
        </app-repeat-click-button>
        <input
          type="number"
          class="form-control form-control-sm report-page-input"
          [ngModel]="activeViewer.page()"
          (ngModelChange)="setViewerPage($event)"
          min="1"
          [max]="activeViewer.pageCount()"
          aria-label="Page number"
          i18n-aria-label
        />
        <span class="text-secondary text-nowrap">/ {{ activeViewer.pageCount() }}</span>
        <app-repeat-click-button
          buttonClass="btn btn-sm btn-outline-secondary border-0 px-2"
          [disabled]="activeViewer.page() >= activeViewer.pageCount()"
          label="Next page"
          i18n-label
          (clicked)="activeViewer.nextPage()"
        >
          <i class="fa fa-chevron-right"></i>
        </app-repeat-click-button>
      </div>

      <div class="vr d-none d-md-block"></div>

      <div class="d-flex align-items-center gap-1">
        <app-repeat-click-button
          buttonClass="btn btn-sm btn-outline-secondary"
          label="Zoom out"
          i18n-label
          (clicked)="activeViewer.zoomOut()"
        >
          <i class="fa fa-minus"></i>
        </app-repeat-click-button>
        <span class="report-zoom-label text-secondary">{{ activeViewer.zoomLabel() }}</span>
        <app-repeat-click-button
          buttonClass="btn btn-sm btn-outline-secondary"
          label="Zoom in"
          i18n-label
          (clicked)="activeViewer.zoomIn()"
        >
          <i class="fa fa-plus"></i>
        </app-repeat-click-button>
        <app-repeat-click-button
          buttonClass="btn btn-sm btn-outline-secondary border-0"
          tooltip="Fit width"
          i18n-tooltip
          label="Fit width"
          i18n-label
          (clicked)="activeViewer.fitWidth()"
        >
          <i class="fa fa-arrows-alt-h"></i>
        </app-repeat-click-button>
      </div>
    }

    @if (selectedReport) {
      <div class="ms-auto d-flex align-items-center gap-2">
        @if (!selectedReport.hideEmail) {
          <button type="button" class="btn btn-success" (click)="onEmail()">
            <i class="fa fa-envelope me-1"></i><span i18n>Email</span>
          </button>
        }
        <button type="button" class="btn btn-info text-white" (click)="onDownload()">
          <i class="fa fa-file-download me-1"></i><span i18n>Download</span>
        </button>
        <button type="button" class="btn btn-primary" (click)="print()">
          <i class="fa fa-print me-1"></i><span i18n>Print</span>
        </button>
        @if (upload()) {
          <button type="button" class="btn btn-secondary" (click)="onUpload()">
            <i class="fa fa-upload me-1"></i><span i18n>Upload</span>
          </button>
        }
      </div>
    }
  </div>

  <div #reportContent class="report-content">
    @if (selectedReport) {
      <ng-template [ngTemplateOutlet]="selectedReport.template"></ng-template>
    }
  </div>
}
